export default {
  SET_COOKIE_CONSENT: "SET_COOKIE_CONSENT",
  // SPLASH_SCREEN: 'SPLASH_SCREEN',
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  SETDATE: "SETDATE",
  SETPERIOD: "SETPERIOD",
  SUBSCRIBE_TO_MOMENT_REMINDERS: "SUBSCRIBE_TO_MOMENT_REMINDERS"
};
